module.exports = __webpack_public_path__ + "static/img/HomAptRealtyLogo.6c25c54.svg";


//////////////////
// WEBPACK FOOTER
// ./static/HomAptRealtyLogo.svg
// module id = dy0G
// module chunks = 1